import { EstateSearchProps } from '@portals/sip-client-data/src/general/ApiClientTypes';
import React, { createContext, useCallback, useEffect, useRef } from 'react';

import { useEstateSearchLocalStorage } from '../hooks';

type SavedSearchActionsContextValue = {
  hitSavedSearch: (params: EstateSearchProps) => void;
};

export const SavedSearchActionsContext = createContext<SavedSearchActionsContextValue | undefined>(undefined);

export const SavedSearchActionsProvider: React.FC<{
  callback: (params: EstateSearchProps) => void;
  children: React.ReactNode;
}> = ({ callback, children }) => {
  const { updateLastSearchQuery, lastSearchQuery } = useEstateSearchLocalStorage();
  const shouldTrigger = useRef(false);

  const hitSavedSearch = useCallback(
    (params: EstateSearchProps) => {
      shouldTrigger.current = true;
      updateLastSearchQuery(params);
    },
    [updateLastSearchQuery]
  );

  useEffect(() => {
    if (shouldTrigger.current) {
      callback(lastSearchQuery);
      shouldTrigger.current = false;
    }
  }, [lastSearchQuery, callback]);

  return <SavedSearchActionsContext.Provider value={{ hitSavedSearch }}>{children}</SavedSearchActionsContext.Provider>;
};
